import * as React from 'react';

/**
 * CMS Context
 */ const CmsContext = /*#__PURE__*/ React.createContext(null);
CmsContext.displayName = 'CmsContext';
const useCmsData = ()=>{
    const context = React.useContext(CmsContext);
    if (!context) {
        throw new Error(`No ${CmsContext.displayName} available. You might need to add the ${CmsContext.displayName} provider component.`);
    }
    return context;
};
/**
 * CMS Provider
 */ const CmsProvider = ({ brandPromotions , disclaimer , sizeGuideDocument , usps , purchaseTypeDocument , contactLensesInfoModal , reimbursableLogos , children ,  })=>{
    const value = {
        brandPromotions,
        disclaimer,
        sizeGuideDocument,
        usps,
        purchaseTypeDocument,
        contactLensesInfoModal,
        reimbursableLogos
    };
    return /*#__PURE__*/ React.createElement(CmsContext.Provider, {
        value: value
    }, children);
};

export { CmsContext, CmsProvider, useCmsData };
//# sourceMappingURL=CmsContext.js.map
